// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__32Q1c","loaderOuter":"PageOverlayLoader_loaderOuter__2Govu"};